import { Badge } from '@/shared/ui/badge'
import { Icon } from '@/shared/ui/icon'
import type { Project } from '../model/types'

interface ProjectSummaryProps {
  project: Project
  /** Имя компании (wire отдаёт только company_id — резолвит страница). */
  companyName?: string | undefined
}

// Презентационная строка проекта — плотная строка списка внутри карточки.
// Навигацию навешивает страница.
export function ProjectSummary({ project, companyName }: ProjectSummaryProps) {
  return (
    <div className="flex items-center gap-2.5 rounded-control px-3 py-2 transition-colors hover:bg-bg-raised">
      <Icon name="folder" size={16} className="shrink-0 text-text-tertiary" />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <span className="truncate text-sm font-medium text-text-primary">{project.name}</span>
          {project.archived && <Badge tone="warning">В архиве</Badge>}
        </div>
        {companyName && <div className="text-xs text-text-tertiary">{companyName}</div>}
      </div>
      <Icon name="chevron-right" size={14} className="shrink-0 text-text-tertiary" />
    </div>
  )
}
